import {
    put
  } from 'redux-saga/effects';
  import axios from '../../axios-local-api';
  import * as actions from '../actions';
  import packageJson from '../../../package.json';

  export function* getEntitlementSaga(action) {
    const rMac = yield sessionStorage.getItem('mac');
    const token = yield sessionStorage.getItem('token');

    const sessionToken = yield sessionStorage.getItem('sessionToken');
    //console.log('saga enti', token, sessionToken);
      if (sessionToken) {
      try {
        const response = yield axios.post(
          '/getEntiltment',
          {
            rMac: rMac || '',
            bToken: token,
            sessionToken:sessionToken
          }
        );
        ////console.log(response, 'response');
        if(response.data.status === 200){
            ////console.log(response.data);
            const parsedData = response.data.entitlement;
            yield put(actions.getEntitlementSuccess(parsedData));
            if (parsedData && parsedData.soloId) {
                yield put(actions.getMultiRouterBySoloId(parsedData.soloId));
            }
        }else{

          yield put(actions.getEntitlementFailed());
        }

      } catch (error) {

        yield put(actions.getEntitlementFailed());
      }
    } else {
      //console.log('NO TOKEN')
      yield put(actions.getEntitlementFailed());

    }


  }

  export function* getMultiRouterBySoloId(action) {
    const rMac = yield sessionStorage.getItem('mac');
    const token = yield sessionStorage.getItem('token');

    const sessionToken = yield sessionStorage.getItem('sessionToken');
    //console.log('saga enti', token, sessionToken);
      if (sessionToken) {
      try {
        const response = yield axios.post(
          '/getMultiRouterBySoloId',
          {
            rMac: rMac || '',
            bToken: token,
            sessionToken:sessionToken,
            soloId: action.soloId
          }
        );
        //console.log(response, 'getMultiRouterBySoloId');
        if(response.data.status === 200){
            //console.log(response.data);
            yield put(actions.getMultiRouterBySoloISuccess())
        }else{

          yield put(actions.getMultiRouterBySoloIdFailed());
        }

      } catch (error) {

        yield put(actions.getMultiRouterBySoloIdFailed());
      }
    } else {
      //console.log('NO TOKEN')
      yield put(actions.getMultiRouterBySoloIdFailed());

    }


  }


  export function* createMultipleAdvancedWifiSaga(action) {
    const rMac = yield sessionStorage.getItem('mac');
    const token = yield sessionStorage.getItem('token');

    const sessionToken = yield sessionStorage.getItem('sessionToken');

      if (sessionToken) {
      try {
        const response = yield axios.post(
          '/createMultiRouter',
          {
            rMac: rMac || '',
            bToken: token,
            sessionToken:sessionToken,
            soloId: action.soloId
          }
        )
        if(response.data.status === 200){
        yield put(actions.createMultipleadvancedHomeWifiSuccess());
        yield put(actions.getMultiRouterBySoloId(action.soloId));
        }else{
          //console.log('FAILED UPNP')
          yield put(actions.createMultipleadvancedHomeWifiFailed());
        }
      } catch (error) {
        console.error('FAILED UPNP')
        yield put(actions.createMultipleadvancedHomeWifiFailed());
      }
    } else {
      //console.log('NO TOKEN')
      yield put(actions.createMultipleadvancedHomeWifiFailed());
    }

  }

  export function* deleteMultipleAdvancedWifiSaga(action) {
    const rMac = yield sessionStorage.getItem('mac');
    const token = yield sessionStorage.getItem('token');

    const sessionToken = yield sessionStorage.getItem('sessionToken');

      if (sessionToken) {
      try {
        const response = yield axios.post(
          '/deleteMultiRouter',
          {
            rMac: rMac || '',
            bToken: token,
            sessionToken:sessionToken,
            soloId: action.soloId
          }
        )
        if(response.data.status === 200){
        yield put(actions.deleteMultipleadvancedHomeWifiSuccess());
        yield put(actions.getMultiRouterBySoloId(action.soloId));
        }else{
          //console.log('FAILED UPNP')
          yield put(actions.deleteMultipleadvancedHomeWifiFailed());
        }
      } catch (error) {
        console.error('FAILED UPNP')
        yield put(actions.deleteMultipleadvancedHomeWifiFailed());
      }
    } else {
      //console.log('NO TOKEN')
      yield put(actions.deleteMultipleadvancedHomeWifiFailed());
    }

  }

